export default {
  common__validation__is_required: '請輸入',
  common__validation__invalid_format: '請輸入正確的值',
  common__validation__invalid_file_size: '檔案大小超過上限（{size}）',
};
